import React from 'react';

const HeaderImage = ({ type }) => {
	if (!type) {
		return null;
	}

	let imageSrc;
	let altText;
	switch (type) {
		case 'GenomicInsights':
			imageSrc = '/images/cellscience/GenomicInsights.webp';
			altText = 'Genomic Insights';
			break;
		case 'CNA':
			imageSrc = '/images/cellscience/CNA.webp';
			altText = 'Cellular Nutrition Assays';
			break;
		default:
			return null;
	}

	return (
		<img
			src={imageSrc}
			alt={altText}
			style={{
				height: '25px',
				width: 'auto',
				alignSelf: 'center'
			}}
		/>
	);
};

export default HeaderImage;
